import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export const CTASection = () => {
  return (
    <section className="py-14 sm:py-16 lg:py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 gradient-primary" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-6 sm:left-16 w-72 h-72 sm:w-96 sm:h-96 bg-background/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 right-6 sm:right-16 w-72 h-72 sm:w-96 sm:h-96 bg-background/10 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, type: "spring" }}
            className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-background/20 flex items-center justify-center mx-auto mb-5 sm:mb-6"
          >
            <Sparkles className="h-7 w-7 sm:h-8 sm:w-8 text-primary-foreground" />
          </motion.div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-primary-foreground mb-4 sm:mb-6">
            Your Business Has a Problem. We Build the Right Digital{" "}
            <span className="text-white">Solution.</span>
          </h2>

          <p className="text-base sm:text-lg text-primary-foreground/80 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed">
            Let’s talk about what your business actually needs to grow online.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
            <Button
              variant="premium"
              size="xl"
              asChild
              className="group bg-background text-foreground hover:bg-background/90 w-full sm:w-auto justify-center"
            >
              <Link
                to="/contact"
                className="flex items-center justify-center gap-2"
              >
                Book a Free Consultation
                <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>

            <Button
              variant="glass"
              size="xl"
              asChild
              className="group bg-background text-foreground hover:bg-background/90 w-full sm:w-auto justify-center"
            >
              <Link to="/contact" className="flex items-center justify-center">
                Contact Us
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};